import React, { Component, Fragment } from "react";
import pluralize from 'pluralize';
import CartLineItem from "./CartLineItem";

class CartList extends Component {
  renderFreeShippingMessage(condition) {
    const totalCartItems = this.props.cart.items.filter(i => ![4775207731266, 6967317200962].includes(i.product_id) && i.vendor != 're:do').reduce((acc, i) => i.quantity + acc, 0);
    const total = condition == 'item_count' ? totalCartItems : (this.props.cart.total_price / 100);
    const minimum = theme.freeShippingMinimum;
    const dif = minimum - total;
    if (dif > 0) {
      return (
        <>
          {condition == 'item_count'
            ? <span> You're <em>{dif}</em> {pluralize('product', dif)} away from free shipping!</span>
            : <span> You're <em>${dif}</em> away from free shipping!</span>
          }
          <progress
            className="freeShippingBar"
            value={total}
            max={minimum}
          />
        </>
      );
    } else {
      return (
        <>
          <span>
            Congratulations! You've got <em>free shipping!</em>
          </span>
          <progress className="freeShippingBar" value="1" max="1" />
        </>
      );
    }
  }
  render() {
    const products = this.props.products;
    if (products == undefined || products.length < 1) {
      return (
        <div className="Loop Loop--minicart">
          <div className="empty-loop">
            You don't have any items in your cart.
          </div>
        </div>
      );
    } else {
      return <Fragment>
        <div className="Loop Loop--minicart">
          {products.map((product) => (
            <CartLineItem
              product={product}
              key={product.id}
              updateLineQuantity={this.props.updateLineQuantity}
            />
          ))}
        </div>
        <ul className="MiniCart__totals">
          {this.props.cart.total_discount > 0 && <li>
            <span className="label">Discounts</span>
            <span className="discount">
              ${(this.props.cart.total_discount / 100).toFixed(2)}
            </span>
          </li>}
          <div className="freeShippingMsg">
            {theme.freeShippingMinimum > 0 && this.renderFreeShippingMessage(theme.freeShippingCondition)}
            {/* <a href="/collections/shop-all-baby">Shop Wildbird Baby!</a> */}
          </div>
          <li className="subtotal">
            <span className="label">Subtotal</span>
            <span className="total">
              ${(this.props.cart.total_price / 100).toFixed(2)}
            </span>
          </li>
          <li className="notes">
            Shipping and taxes calculated at checkout.
          </li>
        </ul>
        <a href="/cart" className="Button Button--primary Button--block">
          View Cart
        </a>
        <a href="/checkout" className="Button Button--primary Button--block Button--checkout">
          Checkout
        </a>
        {/* <form action="/cart" method="post" noValidate>
            <button type="submit" name="cart" className="Button Button--primary Button--block">
              View Cart
            </button>
          </form> */}
      </Fragment>;
    }
  }
}

export default CartList;
